package com.milta.core.localization.translations.sq

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Duke ngarkuar…",
    errorNoConnection = "Nuk mund të kontaktohet serveri — kontrollo lidhjen tënde.",
    errorGeneric = "Ndodhi një gabim. Provo përsëri më vonë.",
    readOnlyNotice = "🔒 Vetëm për shikim — asnjë llogari nuk mund të krijohet, modifikohet apo pezullohet nga ky ekran për momentin.",
    kpiAccountsLabel = "Llogaritë",
    kpiAccountsSubtitle = "të gjitha rolet së bashku",
    kpiDriversLabel = "Shoferët",
    kpiDriversSubtitle = "pa ekip të vetin",
    kpiPatronsLabel = "Pronarët",
    kpiPatronsOrgSingular = "organizatë",
    kpiPatronsOrgPlural = "organizata",
    kpiActiveSubsLabel = "Abonime aktive",
    kpiActiveSubsSubtitle = "aktiv + periudhë mirëkuptimi",
    kpiAtRiskLabel = "Në rrezik",
    kpiAtRiskSubtitle = "provë ose skaduar",
    searchPlaceholder = "Kërko sipas emrit, email-it, organizatës…",
    expandAllAction = "Zgjero të gjitha",
    collapseAllAction = "Mbyll të gjitha",
    columnAccount = "Llogaria",
    columnContact = "Kontakti",
    columnType = "Lloji",
    columnAddedDate = "Shtuar / krijuar më",
    columnSubscription = "Abonimi",
    columnSince = "Që nga",
    columnRenewal = "Rinov.",
    noOrganizationHeader = "Pa organizatë",
    emptySearchResult = "Asnjë llogari nuk përputhet me këtë kërkim.",
    patronBadgePrefix = "Pronar",
    createdOnPrefix = "Krijuar më",
    emptyTeamMessage = "Ende asnjë shofer në këtë ekip.",
    driverBadge = "Shofer",
    addedOnPrefix = "Shtuar më",
    viaOrganization = "Përmes organizatës",
    accountCreatedOnUnknown = "Llogaria krijuar më —",
    renewalSingular = "rinovim",
    renewalPlural = "rinovime",
    subscriptionNone = "Asnjë",
    subscriptionActive = "Aktiv",
    subscriptionTrial = "Provë",
    subscriptionGrace = "Mirëkuptim",
    subscriptionExpiredStatus = "Skaduar",
    subscriptionCancelled = "Anuluar",
    planOrganization = "Organizatë",
    planDriver = "Shofer",
)
